(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-global-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const showLogoTextFallback = (image) => {
      image.hidden = true;
      image.closest('.header-logo')?.classList.add('fk-logo-text-fallback');
    };

    const retryHeaderLogo = (image) => {
      const sourceValue = image.currentSrc || image.src;

      if (!sourceValue) {
        showLogoTextFallback(image);
        return;
      }

      const source = new URL(sourceValue, window.location.origin);
      const version = source.searchParams.get('v');
      source.search = '';

      if (version) source.searchParams.set('v', version);

      image.removeAttribute('srcset');
      image.addEventListener('error', () => showLogoTextFallback(image), { once: true });
      image.src = source.toString();
    };

    const prepareHeaderLogos = (root) => {
      const images = [];

      if (root instanceof Element && root.matches('.header-logo__image')) {
        images.push(root);
      }

      if ('querySelectorAll' in root) {
        images.push(...root.querySelectorAll('.header-logo__image'));
      }

      images.forEach((image) => {
        if (image.dataset.fkLogoPrepared === 'true') return;

        image.dataset.fkLogoPrepared = 'true';
        image.addEventListener('error', () => retryHeaderLogo(image), { once: true });

        if (image.complete && image.naturalWidth === 0) {
          retryHeaderLogo(image);
        }
      });
    };

    prepareHeaderLogos(document);

    const logoObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) prepareHeaderLogos(node);
        });
      });
    });

    logoObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

    const rules = [
      { selector: '.fk-home-hero__visual', direction: 'right' },
      { selector: '.fk-value-strip__item', direction: 'up', stagger: true },
      { selector: '.fk-category-navigation__card', direction: 'up', stagger: true },
      { selector: '.fk-b2b-panel__media', direction: 'left' },
      { selector: '.fk-b2b-panel__content', direction: 'right' },
      { selector: '[id*="section_VdMUrq"] .image-block', direction: 'left' },
      { selector: '[id*="section_VdMUrq"] .group-block', direction: 'right' },
      { selector: '.product-information .product-details', direction: 'right' },
      { selector: '.fk-product-description__header', direction: 'left' },
      { selector: '.fk-product-description__content', direction: 'right' },
      { selector: '[id*="section_eMiaGR"] .image-block', direction: 'left' },
      { selector: '[id*="section_eMiaGR"] .group-block', direction: 'right' },
      { selector: '.resource-list__item, .product-grid__item', direction: 'up', stagger: true }
    ];

    const observed = new WeakSet();
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fk-reveal--visible');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    const prepare = (element, direction, delay) => {
      if (!(element instanceof HTMLElement) || observed.has(element)) return;

      observed.add(element);
      element.classList.add('fk-reveal');

      if (direction === 'left' || direction === 'right') {
        element.classList.add(`fk-reveal--${direction}`);
      }

      element.style.setProperty('--fk-reveal-delay', `${delay}ms`);
      revealObserver.observe(element);
    };

    const scan = (root) => {
      rules.forEach((rule) => {
        const matches = [];

        if (root instanceof Element && root.matches(rule.selector)) {
          matches.push(root);
        }

        if ('querySelectorAll' in root) {
          matches.push(...root.querySelectorAll(rule.selector));
        }

        matches.forEach((element, index) => {
          const delay = rule.stagger ? Math.min((index % 4) * 110, 330) : 0;
          prepare(element, rule.direction, delay);
        });
      });
    };

    document.documentElement.classList.add('fk-motion-enabled');
    scan(document);

    const mutationObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-uniform-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots=document.querySelectorAll('.fk-uf:not([data-ready])');
  roots.forEach(function(root){
    root.dataset.ready='1';
    var state={gender:null,region:null,material:null};
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var nav=[].slice.call(root.querySelectorAll('[data-nav]'));

    var products={
      'men-serge-normal':'herren-sakko-serge-bayern-bremen-klassisch-repraesentativ',
      'men-serge-short':'herren-sakko-serge-bayern-bremen-klassisch-reprasentativ-formstabil-untersetzte-grossen',
      'men-serge-slim':'herren-sakko-serge-bayern-bremen-klassisch-reprasentativ-formstabil-schlanke-grossen',
      'men-serge-belly':'herren-sakko-serge-bayern-bremen-klassisch-reprasentativ-formstabil-bauch-grossen',
      'men-trikot-normal':'herren-sakko-trikot-bayern-bequem-alltagstauglich-robust-normale-grossen',
      'men-trikot-short':'herren-sakko-trikot-bayern-bequem-alltagstauglich-robust-untersetzte-grossen',
      'men-trikot-slim':'herren-sakko-trikot-bayern-bequem-alltagstauglich-robust-schlanke-grossen',
      'men-trikot-belly':'herren-sakko-trikot-bayern-bequem-alltagstauglich-robust-bauch-grossen',
      'women-serge-normal':'damen-blazer-serge-bayern-bremen-klassisch-repraesentativ',
      'women-serge-short':'damen-blazer-serge-bayern-bremen-klassisch-reprasentativ-formstabil-kurze-grossen',
      'men-fresko-normal':'feuerwehr-uniform-herren-sakko-fresko-nordrhein-westfalen-nrw-normal-grossen-48-68',
      'men-fresko-short':'feuerwehr-uniform-herren-sakko-fresko-nordrhein-westfalen-nrw-untersetzte-grossen-24-31',
      'men-fresko-slim':'feuerwehr-uniform-herren-sakko-fresko-nordrhein-westfalen-nrw-schlanke-grossen-90-114',
      'women-fresko-normal':'feuerwehr-uniform-damen-blazer-fresko-nordrhein-westfalen-nrw-normal-grossen-34-58',
      'women-fresko-short':'feuerwehr-uniform-damen-blazer-fresko-nordrhein-westfalen-nrw-kurze-grossen-19-29',
      'child-serge':'herren-sakko-serge-bayern-klassisch-reprasentativ-formstabil-kinder-grossen',
      'child-trikot':'herren-sakko-trikot-bayern-bequem-alltagstauglich-robust-kinder-grossen'
    };

    var extras={
      shirtMen:'uniformhemd-langarm-hellblau-feuerwehr-bos-jn682',
      shirtWomen:'uniformbluse-langarm-hellblau-damen-feuerwehr-bos-jn681',
      tie:'feuerwehr-krawatte-blau-mit-schnellverschluss',
      badge:'individuelles-aluminium-namensschild-mit-sicherheitsnadel',
      insignia:'feuerwehr-bayern-mutzen-kragenabzeichen-altsilber-art-102451',
      cockade:'feuerwehr-bayern-kokarde-blau-silber-mutzenkokarde-bayern-art-102444'
    };

    var men=[
      ['normal','42',164,84,74,94,60],['normal','44',168,88,78,98,61],['normal','46',171,92,82,102,62],['normal','48',174,96,86,106,63],['normal','50',177,100,90,110,64],['normal','52',180,104,94,114,65],['normal','54',182,108,100,118,66],['normal','56',184,112,104,121,67],['normal','58',186,116,110,124,68],['normal','60',188,120,114,128,69],['normal','62',190,124,118,132,70],['normal','64',192,128,122,136,71],['normal','66',194,132,126,140,72],['normal','68',196,136,130,144,73],
      ['short','23',165,92,86,102,60],['short','24',168,96,90,106,61],['short','25',171,100,94,110,62],['short','26',174,104,98,114,63],['short','27',176,108,102,118,64],['short','28',178,112,108,122,65],['short','29',180,116,112,126,66],['short','30',182,120,116,130,67],['short','31',184,124,120,134,68],['short','32',186,128,124,138,69],['short','33',188,132,128,142,70],
      ['slim','88',176,86,76,98,64],['slim','90',177,88,78,100,64],['slim','94',180,92,82,104,66],['slim','98',183,96,86,108,67],['slim','102',186,100,90,112,69],['slim','106',188,104,94,116,70],['slim','110',190,108,98,120,71],['slim','114',192,112,102,124,72],['slim','118',194,116,106,128,73],
      ['belly','47',166,92,98,104,60],['belly','49',168,96,102,108,61],['belly','51',170,100,106,112,62],['belly','53',172,104,112,116,63],['belly','55',174,108,116,120,64],['belly','57',176,112,122,124,65],['belly','59',178,116,126,128,66],['belly','61',180,120,130,132,66],['belly','63',182,124,134,136,67],['belly','65',184,128,138,140,67],['belly','67',186,132,142,144,68],['belly','69',188,136,146,148,68]
    ].map(function(r){return{family:r[0],size:r[1],height:r[2],chest:r[3],waist:r[4],hip:r[5],arm:r[6]};});

    var women=[
      ['normal','34',80,60,87,59.4],['normal','36',84,64,91,59.8],['normal','38',88,68,95,60.2],['normal','40',92,72,99,60.6],['normal','42',96,76,103,61],['normal','44',100,80,107,61.4],['normal','46',104,84,111,61.8],['normal','48',110,90,116,62.2],['normal','50',116,96,122,62.6],['normal','52',122,102,127,63],['normal','54',128,108,134,63.4],['normal','56',134,114,140,63.8],['normal','58',140,120,146,64.2],
      ['short','19',89,68,95,58],['short','20',93,72,99,58.4],['short','21',97,76,103,58.8],['short','22',101,80,107,59.2],['short','23',105,84,111,59.6],['short','24',111,90,116,60],['short','25',117,96,122,60.4],['short','26',123,102,128,60.8],['short','27',129,108,134,61.2],['short','28',135,114,140,61.6],['short','29',141,120,146,62]
    ].map(function(r){return{family:r[0],size:r[1],chest:r[2],waist:r[3],hip:r[4],arm:r[5]};});

    function showStep(n){
      steps.forEach(function(s){var a=Number(s.dataset.step)===n;s.hidden=!a;});
      nav.forEach(function(x){var v=Number(x.dataset.nav);x.classList.toggle('is-active',v===n);x.classList.toggle('is-done',v<n);});
    }
    function selected(name){var x=root.querySelector('input[name="'+name+'"]:checked');return x?x.value:null;}
    function err(n,msg){var e=root.querySelector('[data-step="'+n+'"] .fk-uf__error');e.textContent=msg||'';e.hidden=!msg;}
    function familyName(f){if(f==='short')return state.gender==='men'?'Untersetzte Größe':'Kurzgröße';if(f==='slim')return'Schlanke Größe';if(f==='belly')return'Bauchgröße';return'Normalgröße';}
    function loadMaterialVisuals(){
      var sergeHandle=state.gender==='women'?products['women-serge-normal']:(state.gender==='child'?products['child-serge']:products['men-serge-normal']);
      var trikotHandle=state.gender==='child'?products['child-trikot']:products['men-trikot-normal'];
      var freskoHandle=state.gender==='women'?products['women-fresko-normal']:products['men-fresko-normal'];
      [{type:'serge',handle:sergeHandle},{type:'trikot',handle:trikotHandle},{type:'fresko',handle:freskoHandle}]
        .filter(function(x){
          var card=root.querySelector('[data-material="'+x.type+'"]');
          return card && !card.hidden && !card.classList.contains('disabled');
        })
        .forEach(function(x){
        fetchProduct(x.handle).then(function(p){
          var img=root.querySelector('[data-fabric-img="'+x.type+'"]');
          var zoom=root.querySelector('[data-fabric-zoom="'+x.type+'"]');
          if(img){img.src=p.featured_image||'';img.alt=(x.type==='serge'?'Serge':'Trikot')+' Feuerwehruniform';}
          if(zoom&&p.featured_image)zoom.style.backgroundImage='url("'+p.featured_image.replace(/"/g,'')+'")';
        }).catch(function(){});
      });
    }
    function configureMaterial(){
      var sergeCard=root.querySelector('[data-material="serge"]');
      var trikotCard=root.querySelector('[data-material="trikot"]');
      var freskoCard=root.querySelector('[data-material="fresko"]');
      var notice=root.querySelector('[data-material-notice]');
      var materials=root.querySelector('.fk-uf__materials');

      if(state.region==='nrw'){
        sergeCard.hidden=true;trikotCard.hidden=true;freskoCard.hidden=false;
        sergeCard.querySelector('input').disabled=true;trikotCard.querySelector('input').disabled=true;freskoCard.querySelector('input').disabled=false;
        freskoCard.querySelector('input').checked=true;
        state.material='fresko';
        materials.classList.add('is-single');
        notice.hidden=false;
        notice.textContent='Für Nordrhein-Westfalen verwendet der Finder die Fresko-Ausführung der Novotex-Uniform.';
        loadMaterialVisuals();
        return;
      }

      sergeCard.hidden=false;trikotCard.hidden=false;freskoCard.hidden=true;
      sergeCard.querySelector('input').disabled=false;freskoCard.querySelector('input').disabled=true;
      materials.classList.remove('is-single');

      var input=trikotCard.querySelector('input');
      var ok=(state.gender==='men'||state.gender==='child')&&state.region!=='bremen';
      trikotCard.classList.toggle('disabled',!ok);input.disabled=!ok;
      var unavailableText=state.gender==='women'?'Im aktuellen Damen-Sortiment ist der Blazer als Serge verfügbar.':'Für Bremen ist Trikot nicht als passender Novotex-Artikel hinterlegt.';
      trikotCard.querySelector('em').textContent=ok?'':unavailableText;
      if(!ok){
        root.querySelector('input[value="serge"]').checked=true;
        state.material='serge';
        notice.hidden=false;
        notice.textContent=state.gender==='women'?'Der Finder nutzt für Damen aktuell den Serge-Blazer.':'Für Bremen wird die Serge-Ausführung Art.-Nr. 20-100 verwendet.';
      }else{
        notice.hidden=true;
      }
      loadMaterialVisuals();
    }
    function measures(){
      var o={};root.querySelectorAll('[data-measure]').forEach(function(i){
        if(i.closest('[hidden]'))return;
        var raw=(i.value||'').trim();
        if(raw==='')return;
        var v=Number(raw);
        if(Number.isFinite(v))o[i.dataset.measure]=v;
      });return o;
    }
    function measureLabel(key){
      return{height:'Körperhöhe',chest:'Brustumfang',waist:'Taillenumfang',hip:'Hüftumfang',arm:'Armlänge'}[key]||'Maß';
    }
    function tableRange(key){
      var ranges={
        men:{height:[164,196],chest:[84,136],waist:[74,146],hip:[94,148],arm:[60,73]},
        women:{chest:[80,141],waist:[60,120],hip:[87,146],arm:[58,64.2]}
      };
      return ranges[state.gender]&&ranges[state.gender][key]?ranges[state.gender][key]:null;
    }
    function measureIssue(key){
      var input=root.querySelector('[data-measure="'+key+'"]');
      if(!input)return{key:key,type:'missing',message:'Dieses Maß konnte nicht gefunden werden.'};
      var raw=(input.value||'').trim();
      if(raw==='')return{key:key,type:'empty',message:'Bitte trage '+measureLabel(key).toLowerCase()+' ein.'};
      var value=Number(raw);
      if(!Number.isFinite(value)||value<=0)return{key:key,type:'invalid',message:'Bitte trage für '+measureLabel(key).toLowerCase()+' einen gültigen Wert in cm ein.'};

      if(state.gender==='child'&&key==='height'){
        if(value<134||value>194){
          return{key:key,type:'unsupported',message:'Für eine Körperhöhe von '+value+' cm können wir aus den verfügbaren Kindergrößen 140, 152, 164, 176 und 188 keine passende Vorauswahl ermitteln. Bitte kontaktiere uns zur individuellen Beratung.'};
        }
        return null;
      }

      var range=tableRange(key);
      if(range&&(value<range[0]||value>range[1])){
        var person=state.gender==='men'?'Herren':'Damen';
        return{key:key,type:'unsupported',message:'Der eingegebene Wert für '+measureLabel(key)+' ('+value+' cm) liegt außerhalb der hinterlegten '+person+'-Körpermaßtabelle ('+range[0]+'–'+range[1]+' cm). Dafür kann der Finder keine passende Größe bestimmen.'};
      }
      return null;
    }
    function validateMeasures(need){
      var issues=[];
      need.forEach(function(k){
        var input=root.querySelector('[data-measure="'+k+'"]');
        var label=input?input.closest('label'):null;
        var issue=measureIssue(k);
        if(label)label.classList.toggle('is-invalid',!!issue);
        if(input)input.setAttribute('aria-invalid',issue?'true':'false');
        if(issue)issues.push(issue);
      });
      return issues;
    }
    var measureSequence=[];var measureIndex=0;
    function setupMeasureAssistant(){
      measureSequence=state.gender==='men'?['height','chest','waist','hip','arm']:(state.gender==='child'?['height']:['chest','waist','hip','arm']);
      measureIndex=0;
      root.classList.toggle('fk-uf--men',state.gender==='men');
      root.classList.toggle('fk-uf--women',state.gender==='women');
      root.classList.toggle('fk-uf--child',state.gender==='child');
      var personBadge=root.querySelector('[data-measure-person]');
      if(personBadge)personBadge.textContent=state.gender==='men'?'Herren-Maßhilfe':(state.gender==='child'?'Kinder-Maßhilfe':'Damen-Maßhilfe');
      var intro=root.querySelector('[data-measure-intro]');
      if(intro)intro.innerHTML=state.gender==='child'
        ?'<strong>Kinder-Vorauswahl:</strong> Solange uns die vollständige Novotex-Körpermaßtabelle für 140–188 nicht vorliegt, verwenden wir ausschließlich die Körperhöhe. Das Ergebnis ist eine Orientierung und keine vollständige Passformberechnung.'
        :'Wir führen dich durch jede Messung einzeln. <strong>Wichtig:</strong> Wir brauchen deine Körpermaße, nicht die Maße eines vorhandenen Sakkos oder Blazers.';
      var heightInput=root.querySelector('[data-measure="height"]');
      if(heightInput){
        heightInput.min='1';
        heightInput.max='250';
        heightInput.placeholder=state.gender==='child'?'152':'180';
      }
      root.querySelectorAll('[data-model-gender]').forEach(function(img){
        var active=img.dataset.modelGender===state.gender;
        img.style.display=active?'block':'none';
        img.style.opacity='1';
        img.style.visibility='visible';
        if(active&&!img.getAttribute('src')&&img.dataset.src){
          img.setAttribute('src',img.dataset.src);
        }
      });
      root.querySelectorAll('.fk-overlay-men').forEach(function(el){el.style.display=state.gender==='men'?'inline':'none';});
      root.querySelectorAll('.fk-overlay-women').forEach(function(el){el.style.display=state.gender==='women'?'inline':'none';});
      showMeasureCard();
    }
    function showMeasureCard(){
      var key=measureSequence[measureIndex];
      root.querySelectorAll('[data-measure-card]').forEach(function(card){
        var active=card.dataset.measureCard===key;
        card.hidden=!active;
        card.style.display=active?'grid':'none';
      });
      var total=measureSequence.length;
      var activeCard=root.querySelector('[data-measure-card="'+key+'"]');
      if(activeCard){
        var counter=activeCard.querySelector('[data-measure-counter]');
        var progress=activeCard.querySelector('[data-measure-progress]');
        if(counter)counter.textContent=(measureIndex+1)+' von '+total;
        if(progress)progress.style.width=((measureIndex+1)/total*100)+'%';
      }
      root.querySelectorAll('[data-measure-counter]').forEach(function(el){
        if(!el.closest('[data-measure-card="'+key+'"]')) el.textContent='';
      });
      var back=root.querySelector('[data-measure-back]');
      var next=root.querySelector('[data-measure-next]');
      var calc=root.querySelector('[data-calc]');
      back.textContent=measureIndex===0?'Zurück zur Ausführung':'Vorheriges Maß';
      next.hidden=measureIndex===total-1;
      calc.hidden=measureIndex!==total-1;
      /* Kein automatischer Fokus: verhindert Layout-/Scrollsprünge beim Kartenwechsel. */
    }
    function validateOneMeasure(key){
      var input=root.querySelector('[data-measure="'+key+'"]');
      if(!input)return{key:key,type:'missing',message:'Dieses Maß konnte nicht gefunden werden.'};
      var issue=measureIssue(key);
      var label=input.closest('.fk-uf__measure-input');
      if(label)label.classList.toggle('is-invalid',!!issue);
      input.setAttribute('aria-invalid',issue?'true':'false');
      return issue;
    }
    function score(row,v){
      var scale={height:4,chest:4,waist:4,hip:4,arm:2},weight={height:.75,chest:1.55,waist:1.8,hip:1.15,arm:.75},total=0,max=0;
      Object.keys(v).forEach(function(k){if(row[k]==null)return;var d=(v[k]-row[k])/scale[k];if((k==='chest'||k==='waist'||k==='hip')&&d>0)d*=1.15;total+=weight[k]*d*d;max=Math.max(max,Math.abs(d));});
      return{row:row,score:total,max:max};
    }
    function money(cents){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';return new Intl.NumberFormat('de-DE',{style:'currency',currency:cur}).format(cents/100);}
    var productCache=Object.create(null);
    function fetchProduct(handle){
      if(productCache[handle])return productCache[handle];
      productCache[handle]=fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'products/'+handle+'.js',{credentials:'same-origin'})
        .then(function(r){if(!r.ok)throw new Error('product');return r.json();})
        .catch(function(err){delete productCache[handle];throw err;});
      return productCache[handle];
    }
    function mainHandle(row){
      if(state.gender==='child')return products['child-'+state.material];
      if(state.region==='nrw')return products[(state.gender==='women'?'women-fresko-':'men-fresko-')+row.family];
      return products[(state.gender==='women'?'women-serge-':'men-'+state.material+'-')+row.family];
    }
    function renderRefs(row){
      var ref=root.querySelector('[data-result-ref]'),names={height:'Körperhöhe',chest:'Brust',waist:'Taille',hip:'Hüfte',arm:'Armlänge'};ref.innerHTML='';
      ['height','chest','waist','hip','arm'].forEach(function(k){if(row[k]==null)return;var dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=names[k];dd.textContent=row[k]+' cm';ref.appendChild(dt);ref.appendChild(dd);});
    }
    function renderProduct(row){
      var link=root.querySelector('[data-product-link]');link.textContent='Produkt wird geladen …';link.removeAttribute('href');
      fetchProduct(mainHandle(row)).then(function(p){
        var v=p.variants.find(function(x){return String(x.title)===String(row.size);});
        root.querySelector('[data-product-title]').textContent=p.title;
        root.querySelector('[data-product-price]').textContent=money(p.price);
        var img=root.querySelector('[data-product-img]');img.src=p.featured_image||'';img.alt=p.title;
        link.href=p.url+(v?'?variant='+v.id:'');link.textContent=v?'Produkt in Größe '+row.size+' ansehen':'Produkt ansehen';
      }).catch(function(){link.textContent='Produkt derzeit nicht verfügbar';});
    }
    function extraCard(p,tag,desc){
      return'<article class="fk-uf__extra">'+(p.featured_image?'<img src="'+p.featured_image+'" alt="" loading="lazy">':'')+'<div><small>'+tag+'</small><h3>'+p.title+'</h3><p>'+desc+'</p><a href="'+p.url+'">Ansehen</a></div></article>';
    }
    function renderExtras(){
      if(state.gender==='child'){
        root.querySelector('[data-extras]').innerHTML='<article class="fk-uf__extra"><div><small>Kinderuniform</small><h3>Zubehör separat prüfen</h3><p>Hemd, Krawatte und Metallzubehör ordnen wir für Kinder erst automatisch zu, wenn die passenden Vorgaben und Größen eindeutig hinterlegt sind.</p></div></article>';
        root.querySelector('[data-extra-note]').textContent='So vermeiden wir, Erwachsenen-Zubehör oder funktionsabhängige Metallteile fälschlich als passend vorzuschlagen.';
        return;
      }
      var handles=[state.gender==='men'?extras.shirtMen:extras.shirtWomen,extras.badge],tags=[state.gender==='men'?'Uniformhemd':'Uniformbluse','Optional'],descs=['Passende Oberbekleidung zur Dienstuniform. Größe bitte separat auswählen.','Individuelles Namensschild als Ergänzung zur Uniform.'];
      if(state.region==='bayern'){if(state.gender==='men'){handles.push(extras.tie);tags.push('Krawatte');descs.push('Blaue Feuerwehr-Krawatte mit Schnellverschluss. Vorgaben deiner Feuerwehr prüfen.');}handles.push(extras.insignia);tags.push('Metallzubehör');descs.push('Mützen- und Kragenabzeichen. Die Ausführung richtet sich nach Verwendung beziehungsweise Funktion.');}
      Promise.all(handles.map(fetchProduct)).then(function(list){root.querySelector('[data-extras]').innerHTML=list.map(function(p,i){return extraCard(p,tags[i],descs[i]);}).join('');});
      root.querySelector('[data-extra-note]').textContent=state.region==='bayern'?'Die konkrete Ausführung von Abzeichen und weiterem Uniformzubehör hängt von den geltenden Vorgaben und deiner Funktion ab. Der Finder trifft bewusst keine automatische Dienstgrad-Zuordnung.':(state.region==='nrw'?'Für Nordrhein-Westfalen werden derzeit nur eindeutig zuordenbare Zusatzartikel angezeigt. Landes- und funktionsabhängige Metallteile werden bewusst nicht automatisch zugeordnet.':'Für Bremen werden derzeit nur eindeutig zuordenbare Zusatzartikel angezeigt. Landes- und funktionsabhängige Metallteile ergänzen wir erst nach vollständiger Zuordnung.');
    }
    function calculateChild(){
      var invalid=validateMeasures(['height']);
      if(invalid.length){err(3,invalid[0].message);return;}
      var v=measures(),h=v.height,sizes=[140,152,164,176,188];
      var ranked=sizes.map(function(size){return{size:size,diff:Math.abs(h-size)};}).sort(function(a,b){return a.diff-b.diff;});
      err(3,'');
      var best=ranked[0],second=ranked[1],row={family:'child',size:String(best.size),height:best.size,measuredHeight:h};
      root.querySelector('[data-result-family]').textContent='Kindergröße · Vorauswahl';
      root.querySelector('[data-result-size]').textContent=row.size;
      root.querySelector('[data-result-title]').textContent='Vorläufige Empfehlung: Größe '+row.size+'.';
      root.querySelector('[data-result-intro]').textContent='Die Vorauswahl basiert ausschließlich auf der gemessenen Körperhöhe und der nächstliegenden angebotenen Kindergröße.';
      root.querySelector('[data-result-fit]').textContent='Für die Kindergrößen 140–188 liegt uns derzeit keine vollständige Novotex-Körpermaßtabelle vor. Bitte prüfe die Passform vor der Bestellung besonders sorgfältig.';
      var ref=root.querySelector('[data-result-ref]');ref.innerHTML='<dt>Gemessene Körperhöhe</dt><dd>'+h+' cm</dd><dt>Nächstliegende Größenbezeichnung</dt><dd>'+row.size+'</dd>';
      var between=root.querySelector('[data-result-between]');
      if(second&&Math.abs(second.diff-best.diff)<.01){between.hidden=false;between.textContent='Die Körperhöhe liegt genau zwischen den Größen '+best.size+' und '+second.size+'. Bitte beide Größen prüfen oder kurz Rücksprache mit uns halten.';}else{between.hidden=true;}
      var legal=root.querySelector('[data-result-legal]');
      if(legal)legal.textContent='Diese Kinderempfehlung ist ausdrücklich nur eine Vorauswahl nach Körperhöhe. Sie basiert nicht auf einer vollständigen Novotex-Körpermaßtabelle und ersetzt keine Anprobe oder individuelle Beratung.';
      var tableLink=root.querySelector('[data-result-table-link]');if(tableLink)tableLink.hidden=true;
      renderProduct(row);renderExtras();showStep(4);
    }
    function calculate(){
      if(state.gender==='child'){calculateChild();return;}
      var need=state.gender==='men'?['height','chest','waist','hip','arm']:['chest','waist','hip','arm'];
      var invalid=validateMeasures(need);
      if(invalid.length){err(3,invalid[0].message);return;}
      var v=measures();
      err(3,'');var rows=state.gender==='men'?men:women;
      if(state.gender==='men'&&state.material==='trikot'){
        rows=rows.filter(function(r){
          if(r.family==='slim'&&r.size==='88')return false;
          if(r.family==='belly'&&(r.size==='47'||r.size==='49'||r.size==='69'))return false;
          return true;
        });
      }
      if(state.region==='nrw'&&state.gender==='men'){
        rows=rows.filter(function(r){
          var size=Number(r.size);
          if(r.family==='normal')return size>=48&&size<=68;
          if(r.family==='short')return size>=24&&size<=31;
          if(r.family==='slim')return size>=90&&size<=114;
          return false;
        });
      }
      var rank=rows.map(function(r){return score(r,v);}).sort(function(a,b){return a.score-b.score;}),best=rank[0],second=rank[1],row=best.row;
      root.querySelector('[data-result-family]').textContent=familyName(row.family);root.querySelector('[data-result-size]').textContent=row.size;root.querySelector('[data-result-title]').textContent='Wir empfehlen Größe '+row.size+'.';root.querySelector('[data-result-intro]').textContent='Deine Maße passen in der hinterlegten Körpermaßtabelle am besten zur '+familyName(row.family).toLowerCase()+' '+row.size+'.';
      root.querySelector('[data-result-fit]').textContent=best.max<=1.1?'Deine Angaben liegen nah an den Referenzwerten dieser Größe.':best.max<=1.8?'Einzelne Maße liegen zwischen Tabellenwerten. Bitte die Referenzmaße sorgfältig prüfen.':'Mindestens ein Maß weicht deutlicher ab. Nutze das Ergebnis als Orientierung und vergleiche zusätzlich die Maßtabelle.';
      renderRefs(row);var between=root.querySelector('[data-result-between]');if(second&&second.score-best.score<.75){between.hidden=false;between.textContent='Deine Maße liegen nahe an zwei Größenprofilen. Nächste Alternative: '+familyName(second.row.family)+' '+second.row.size+'.';}else between.hidden=true;
      var legal=root.querySelector('[data-result-legal]');if(legal)legal.textContent='Die Empfehlung basiert auf der bei Fireandkisses hinterlegten Körpermaßtabelle und ersetzt keine individuelle Anprobe. Bei Grenzfällen bitte zusätzlich die Maßtabelle prüfen.';
      var tableLink=root.querySelector('[data-result-table-link]');if(tableLink)tableLink.hidden=false;
      renderProduct(row);renderExtras();showStep(4);
    }

    function configureRegionChoices(){
      var isChild=selected('fk-gender')==='child';
      ['bremen','nrw'].forEach(function(region){
        var input=root.querySelector('input[name="fk-state"][value="'+region+'"]');
        var label=root.querySelector('[data-region-label="'+region+'"]');
        if(!input||!label)return;
        input.disabled=isChild;
        label.classList.toggle('disabled',isChild);
        var note=label.querySelector('[data-region-note]');
        if(note)note.textContent=isChild?'Für Kinder nicht verfügbar':'';
        if(isChild&&input.checked)input.checked=false;
      });
    }
    root.querySelectorAll('input[name="fk-gender"]').forEach(function(input){
      input.addEventListener('change',function(){configureRegionChoices();err(1,'');});
    });

    root.addEventListener('click',function(e){
      var b=e.target.closest('button');if(!b)return;
      if(b.dataset.next==='2'){state.gender=selected('fk-gender');state.region=selected('fk-state');if(!state.gender||!state.region){err(1,'Bitte wähle Herren, Damen oder Kinder und ein Bundesland aus.');return;}if(state.gender==='child'&&state.region!=='bayern'){err(1,'Kinderuniformen sind bei Novotex für diese Produktgruppe aktuell nur für Bayern hinterlegt. Bitte wähle Bayern.');return;}err(1,'');configureMaterial();showStep(2);}
      if(b.dataset.next==='3'){state.material=selected('fk-material');if(!state.material){err(2,'Bitte wähle eine verfügbare Stoffausführung aus.');return;}err(2,'');setupMeasureAssistant();showStep(3);}
      if(b.hasAttribute('data-measure-back')){
        if(measureIndex===0){showStep(2);}else{measureIndex--;err(3,'');showMeasureCard();}
      }
      if(b.hasAttribute('data-measure-next')){
        var currentKey=measureSequence[measureIndex];
        var issue=validateOneMeasure(currentKey);
        if(issue){err(3,issue.message);return;}
        err(3,'');measureIndex++;showMeasureCard();
      }
      if(b.dataset.back)showStep(Number(b.dataset.back));
      if(b.hasAttribute('data-calc'))calculate();
      if(b.hasAttribute('data-restart')){state={gender:null,region:null,material:null};root.querySelectorAll('input').forEach(function(i){if(i.type==='radio')i.checked=false;else i.value='';i.removeAttribute('aria-invalid');});root.querySelectorAll('.fk-uf__measure-input').forEach(function(l){l.classList.remove('is-invalid');});showStep(1);}
    });
    root.querySelectorAll('[data-measure]').forEach(function(input){
      input.addEventListener('input',function(){
        var label=input.closest('.fk-uf__measure-input');
        var raw=(input.value||'').trim();
        if(raw===''){if(label)label.classList.remove('is-invalid');input.removeAttribute('aria-invalid');err(3,'');return;}
        var issue=measureIssue(input.dataset.measure);
        if(!issue){if(label)label.classList.remove('is-invalid');input.setAttribute('aria-invalid','false');err(3,'');}
      });
      input.addEventListener('keydown',function(ev){
        if(ev.key==='Enter'){
          ev.preventDefault();
          var next=root.querySelector('[data-measure-next]');
          var calc=root.querySelector('[data-calc]');
          if(!next.hidden)next.click();else if(!calc.hidden)calc.click();
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
